/**
 * Created by Daniel Wang on 2/29/2024.
 * Description:
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, of } from 'rxjs';
import { DialogService, DialogType } from '../../../../../services/dialog.service';
import { catchError, filter, take } from 'rxjs/operators';
import { AlertWindowService } from '../../../../../widgets/alert-window/alert-window.service';
import { AdminPagesService } from '../../../../../tamalelibs/services/admin-page.service';
import { NotificationStyles } from '../../../../../widgets/notification/notification.model';
import { ToastService } from '../../../../../widgets/toast/toast.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../redux';
import { AdminPageActionTypes } from '../../../../../redux/actions/admin-page.actions';
import { adminPageType } from '../../../../../tamalelibs/models/admin-page.model';

@Component({
    selector: 'tam-web-sites-dialog',
    templateUrl: './web-sites-dialog.component.html',
    styleUrls: ['./web-sites-dialog.component.scss']
})
export class WebSitesDialogComponent implements OnInit, OnDestroy {
    //#region public properties
    dialogOpened = false;
    dialogTitle: string;
    filePath = '';
    isFilePathEmpty = false;
    //#endregion

    //#region private properties
    private _destroySubscriptions: Subscription[] = [];
    //#endregion

    //#region constructor
    constructor(
        private _adminPageService: AdminPagesService,
        private _alertWindow: AlertWindowService,
        private _dialogService: DialogService,
        private _store: Store<AppState>,
        private _toast: ToastService,
    ) { }
    //#endregion

    //#region angular functions
    ngOnInit() {
        this.dialogTitle = 'Add sites from file';
        this._initSubscriptions();
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }
    //#endregion

    //#region public functions
    /*
    * check if there were any changes before cancel
    */
    cancelClick() {
        if (this.filePath) {
            const subscription = this._alertWindow.warn('You have unsaved changes',
                ['Are you sure you want to discard all your changes?']).subscribe((result: boolean) => {
                    if (result) {
                        this._onClose();
                    }
                    subscription.unsubscribe();
                });
        } else {
            this._onClose();
        }
    }

    onSumbit() {
        if (this.filePath.trim().length === 0) {
            this.isFilePathEmpty = true;
        } else {
            this._adminPageService.AddWebSiteByFile(this.filePath).pipe(
                take(1),
                catchError(error => {
                    const message = error.message;
                    this._toast.notify({
                        style: NotificationStyles.Success,
                        message: message
                    });
                    return of(null);
                })
            ).subscribe(res => {
                if (res) {
                    // update website storereturn
                    this._store.dispatch({
                        type: AdminPageActionTypes.CREATE_SHARED_PAGE_SUCCESS,
                        payload: {
                            type: adminPageType.webSitesByFile,
                            data: res
                        }
                    });

                    const message = 'Web sites loaded from ' + this.filePath;
                    this._toast.notify({
                        style: NotificationStyles.Success,
                        message: message
                    });
                    this._onClose();
                }
            });
        }
    }
    //#endregion

    //#region private functions
    private _initSubscriptions() {
        this._destroySubscriptions.push(
            this._dialogService.dialogOpen$.pipe(
                filter(item => item.type === DialogType.WebSitesDialog),
            ).subscribe(() => {
                this._resetDialog();
            })
        );
    }

    /*
    * reset dialog parameters after close dialog
    */
    private _onClose() {
        this.dialogOpened = false;
        this.isFilePathEmpty = false;
        this.filePath = '';
    }

    /*
    * reset dialog parameters after create dialog
    */
    private _resetDialog() {
        this.dialogOpened = true;
        this.isFilePathEmpty = false;
        this.filePath = '';
    }
    //#endregion
}
